import { Button } from '@/components/Button';
import { ArrowUpIcon } from '@/components/Icons';
import { EnumSortDirection, SortDirection } from '@/components/Table/types';
import { ColumnDef } from '@/components/TableV2/TableV2';
import { twMerge } from 'tailwind-merge';

type SortableColumnProps<T> = {
  column: ColumnDef<T>;
  sortDirection: SortDirection | undefined;
  onSort: () => void;
};
export const SortableColumn = <T,>({
  column,
  sortDirection,
  onSort,
}: SortableColumnProps<T>) => {
  return (
    <Button
      variant="text"
      disablePadding
      className="group/item gap-1.25 text-xs"
      onClick={onSort}
    >
      {column.render?.() ?? column.name}
      <div
        className={twMerge(
          'flex flex-col gap-0.2 text-intercoastalGray group-hover/item:visible',
          !sortDirection && 'invisible',
        )}
      >
        <ArrowUpIcon
          className={twMerge(
            sortDirection === EnumSortDirection.ascending && 'text-plumBlue',
          )}
        />
        <ArrowUpIcon
          className={twMerge(
            'rotate-180 transform',
            sortDirection === EnumSortDirection.descending && 'text-plumBlue',
          )}
        />
      </div>
    </Button>
  );
};
